<template>
    <div>
        <span @click.stop="projectColumn.property_name==='sales_statuses_code'" v-if="projectColumn.property_name==='sales_statuses_code'">
            <select v-model="projectData.sales_status_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                <option selected></option>
                <option v-for="item in selects.sales_status" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='marketing_status'" v-if="projectColumn.property_name==='marketing_status'">
            <select v-model="projectData.marketing_status_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.marketing_status" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='lead_from'" v-if="projectColumn.property_name==='lead_from'">
            <select v-model="projectData.lead_from_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.lead_from" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='estimator_name'" v-if="projectColumn.property_name==='estimator_name'">
            <select v-model="projectData.estimator_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='account_manager_name'" v-if="projectColumn.property_name==='account_manager_name'">
            <select v-model="projectData.account_manager_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='take_off_person_name'" v-if="projectColumn.property_name==='take_off_person_name'">
            <select v-model="projectData.take_off_person_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='products_and_services'" v-if="projectColumn.property_name==='products_and_services'">
            <select v-model="projectData.products_and_services_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.products_and_services" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='client_profile'" v-if="projectColumn.property_name==='client_profile'">
            <select v-model="projectData.client_profile_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.client_profile" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='contract_type'" v-if="projectColumn.property_name==='contract_type'">
            <select v-model="projectData.contract_type_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.contract_type" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='office'" v-if="projectColumn.property_name==='office'">
            <select v-model="projectData.office_id"
                    @change="getStatusValue($event,projectColumn.property_name,projectData)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in selects.office" :value="item.id">{{ item.full_description }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.property_name==='pre_bid'" v-if="projectColumn.property_name==='pre_bid'">
          <datepicker v-model="projectData.pre_bid" :format="masks"
                      :input-class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''"
                      @keypress.enter.prevent="closeCalendar()"
                      @input="getDateValue(projectColumn.property_name,projectData.pre_bid,projectData)"></datepicker>
        </span>
        <span @click.stop="projectColumn.property_name==='bid_date'" v-if="projectColumn.property_name==='bid_date'">
          <datepicker v-model="projectData.bid_date" :format="masks"
                      :input-class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''"
                      @keypress.enter.prevent="closeCalendar()"
                      @input="getDateValue(projectColumn.property_name,projectData.bid_date,projectData)"></datepicker>
        </span>
        <span @click.stop="projectColumn.is_custom_field===true" v-if="projectColumn.is_custom_field===true && (projectColumn.custom_field_type === 'USER' || projectColumn.custom_field_type === 'DROPDOWN')">
            <select :value="getCustomFieldValue(projectData.custom_field_data, projectColumn.custom_field_id)"
                    @change="getStatusValue($event,projectColumn.custom_field_id,projectData,true)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <option selected></option>
                    <option v-for="item in projectColumn.custom_field_options" :value="item.id">{{ item.name }}</option>
            </select>
        </span>
        <span @click.stop="projectColumn.is_custom_field===true" v-if="projectColumn.is_custom_field===true && projectColumn.custom_field_type === 'TEXT'">
            <input :value="getCustomFieldValue(projectData.custom_field_data, projectColumn.custom_field_id)"
                   type="text"
                   @change="getStatusValue($event,projectColumn.custom_field_id,projectData,true)"
                   class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                   :class="projectData.id == requiredFieldProjectId ? 'required-field-missing' : ''">
        </span>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
export default {
    name: "inline-update",
    props: ['projectColumn', 'projects', 'masks', 'selects', 'requiredFieldProjectIds'],
    components: {Datepicker},
    data() {
        return {
            payload: {
                'inlineColumnType': '',
                'inlineColumnValue': '',
                'project': ''
            },
            requiredFieldProjectId: this.requiredFieldProjectIds,
            projectData: this.projects,
        }
    },
    mounted() {

        Bus.$on('sendRequiredFieldProjectIdRes', data => {
            this.requiredFieldProjectId = data;
        });

        Bus.$on('sendRequiredFieldProjectId', data => {
            this.requiredFieldProjectId = data;
        });
    },
    methods: {
        getStatusValue(event, projectColumn, project, isCustomField=false) {
            projectColumn = this.getRenameColumn(projectColumn);
            this.payload = {
                'inlineColumnType': projectColumn,
                'inlineColumnValue': event.target.value,
                'project': project,
                'isCustomField': isCustomField,
            }
            this.sendPostRequest();
        },
        getDateValue(propertyType,propertyValue , project) {
            propertyValue = moment(propertyValue).local().format('YYYY-MM-DD');
            this.payload = {
                'inlineColumnType': propertyType,
                'inlineColumnValue': propertyValue,
                'project': project
            }
            this.sendPostRequest();
        },
        sendPostRequest() {
            axios.post(route('inline-record-update'), this.payload).then(response => {
                if(response) {
                    let self = this;
                    setTimeout(function(){
                        self.projectUpdatedData();
                    },3000);
                }

            }).catch(error => {
                if(error) {
                    let self = this;
                    setTimeout(function(){
                        self.projectUpdatedData();
                    },3000);
                }
                this.requiredFieldProjectId = this.payload.project.id;

                Bus.$emit('sendRequiredFieldProjectId', this.requiredFieldProjectId);

                this.getToast(5000).fire({
                    type: 'error',
                    title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                });
            })
        },
        getRenameColumn(colunmHeading) {
            let columnVal = '';
            switch (colunmHeading) {
                case 'marketing_status':
                    columnVal = 'marketing_status_id';
                    break
                case 'sales_statuses_code':
                    columnVal = 'sales_status_id';
                    break
                case 'lead_from':
                    columnVal = 'lead_from_id';
                    break
                case 'estimator_name':
                    columnVal = 'estimator_id';
                    break
                case 'account_manager_name':
                    columnVal = 'account_manager_id';
                    break
                case 'take_off_person_name':
                    columnVal = 'take_off_person_id';
                    break
                case 'products_and_services':
                    columnVal = 'products_and_services_id';
                    break
                case 'client_profile':
                    columnVal = 'client_profile_id';
                    break
                case 'contract_type':
                    columnVal = 'contract_type_id';
                    break
                case 'office':
                    columnVal = 'office_id';
                    break
                default:
                    columnVal = colunmHeading;
                    break
            }
            return columnVal;
        },
        getCustomFieldValue(customFieldsData, fieldId) {

            for (var i = 0; i < customFieldsData.length; i++) {

                if (customFieldsData[i].id === fieldId) {

                    return customFieldsData[i].value;
                }
            }
        },
        projectUpdatedData() {
            axios.post(route('project-updated-data'), this.payload).then(response => {
                this.projectData.custom_field_data = response.data.custom_field_data;

                this.projectData.sales_status_id = response.data.project.sales_status_id;
                this.projectData.marketing_status_id = response.data.project.marketing_status_id;
                this.projectData.lead_from_id = response.data.project.lead_from_id;
                this.projectData.estimator_id = response.data.project.estimator_id;
                this.projectData.account_manager_id = response.data.project.account_manager_id;
                this.projectData.take_off_person_id = response.data.project.take_off_person_id;
                this.projectData.products_and_services_id = response.data.project.products_and_services_id;
                this.projectData.client_profile_id = response.data.project.client_profile_id;
                this.projectData.contract_type_id = response.data.project.contract_type_id;
                this.projectData.office_id = response.data.project.office_id;
                this.projectData.pre_bid = response.data.pre_bid;
                this.projectData.bid_date = response.data.bid_date;
            });
        }
    }
}
</script>

<style scoped>
.required-field-missing {
    background: #F78580;
}
</style>
